export const extensionRoutes = [  {
    path: 'extensions/export-orders',
    loadChildren: () => import('./extensions/e658fd0bde74fa298ee9a7492671dac4a1048c54b6691a31393350ff50eb0fec/order-export.module').then(m => m.OrderExportModule),
  },
  {
    path: 'extensions/badges',
    loadChildren: () => import('./extensions/2d2adbd2107b6543bdcadbcc5948e2687d3284fd7e19fcaf2a6fad22ec8e02e1/routes'),
  },
  {
    path: 'extensions/delivery-widget',
    loadChildren: () => import('./extensions/delivery-widget-ui/routes'),
  },
  {
    path: 'extensions/missed-deliveries-widget',
    loadChildren: () => import('./extensions/missed-deliveries-widget-ui/routes'),
  },
  {
    path: 'extensions/gifts',
    loadChildren: () => import('./extensions/gift-plugin/routes'),
  }];
